import { useEffect, useState } from "react";
import { useAuth } from "./AuthContext";
import SubscriberManagement from "./SubscriberManagement";

// Reads ?name=...&phone=... from the URL and passes them into
// SubscriberManagement so the Add form opens pre-filled
export default function AddSubscriberQuick() {
  const { user } = useAuth();
  const [prefill, setPrefill] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const name  = params.get("name")  || "";
    const phone = params.get("phone") || "";
    if (name || phone) {
      setPrefill({ name, phone });
    }
  }, []);

  if (!user) {
    // Not logged in — save the URL and redirect to login
    sessionStorage.setItem("mealbox_redirect", window.location.href);
    window.location.href = "/";
    return null;
  }

  return (
    <SubscriberManagement
      userId={user.id}
      prefillData={prefill}
      autoOpenAdd={true}
    />
  );
}
